// Mock data for Sandeep's portfolio
export const profileData = {
  name: "Sandeep Sinha Mahapatra",
  title: "Software Development Engineer II",
  location: "India",
  email: "sandeep1official@gmail.com",
  social: {
    linkedin: "https://www.linkedin.com/in/7sandeepsinha/",
    twitter: "https://x.com/sndpoffcl",
    github: "https://github.com/7sandeepsinha"
  },
  hero: {
    greeting: "Hi, all",
    name: "Sandeep",
    tagline: "Tech head | Computer geek | Guitarist | Fitness Enthusiast | Tinkerer",
    description: "Building intelligent systems that solve real-world problems at scale"
  },
  about: {
    summary: "I don't just write code—I architect experiences. With over 6 years of building AI-powered solutions at scale, I've learned that the best engineering isn't about the tech stack; it's about solving real problems elegantly. From orchestrating AI agents that handle 110K tickets monthly to designing systems serving hundreds of thousands of users, I thrive in the intersection of innovation and pragmatism.",
    philosophy: "My approach? Start with the user, reverse-engineer the solution, and build it to last. Whether it's automating sales audits with AI or processing millions of shipments daily, I believe in systems that just work—reliably, efficiently, and at scale.",
    interests: "When I'm not deep in microservices architecture or debugging distributed systems, you'll find me strumming my guitar, tinkering with new tech, or exploring entrepreneurial ideas. Because the best solutions often come from unexpected places.",
    highlights: [
      "Built AI agents handling 110K+ tickets/month with >50% resolution rate",
      "Designed systems serving 300K+ daily active users",
      "Developed microservices processing 1M+ shipments per day",
      "Patent holder for AI-powered service request automation"
    ]
  },
  experience: [
    {
      id: 1,
      company: "Atlassian",
      logo: "https://cdn.worldvectorlogo.com/logos/atlassian-1.svg",
      role: "Software Development Engineer II",
      duration: "January 2022 - Present",
      location: "Remote, India",
      achievements: [
        "Built Service AI Agents that generate resolution plans and auto-resolve tickets, handling 110K tickets/month with >50% resolution",
        "Designed orchestration system coordinating AI agents and built agent-facing panel with GraphQL and BFF layer",
        "Developed JSM Virtual Agents with OAuth2 and 3P integrations, enhancing data ingestion for improved resolution",
        "Created embeddable Widgets for JSM with microservices architecture serving ~300K DAU",
        "Enhanced Jira microservices for KB article management, improving user experience"
      ]
    },
    {
      id: 2,
      company: "Ajio.com (Jio Platforms Limited)",
      logo: "https://cdn.worldvectorlogo.com/logos/ajio.svg",
      role: "Software Development Engineer",
      duration: "May 2020 - November 2021",
      location: "Bangalore, India",
      achievements: [
        "Created microservices for manifestation & EWayBill process for B2C and B2B components",
        "Built scalable systems handling around 1M shipments per day"
      ]
    },
    {
      id: 3,
      company: "Capgemini Technology Services India Limited",
      logo: "https://cdn.worldvectorlogo.com/logos/capgemini-2.svg",
      role: "Software Engineer",
      duration: "June 2019 - May 2020",
      location: "Bangalore, India",
      achievements: [
        "Created global risk management application for Morgan Stanley",
        "Developed system to hold records for all incidents across the organization"
      ]
    }
  ],
  skills: {
    languages: ["Kotlin", "Java", "Python", "Javascript"],
    frameworks: ["Spring Boot", "LLM", "RAG", "Vector DB", "Kafka", "Docker", "GraphQL"],
    databases: ["DynamoDB", "SQL/DBMS", "NoSQL", "Redis"],
    concepts: ["Microservices Architecture", "System Design", "Async Communication", "Data Structures & Algorithms"]
  },
  projects: [
    {
      id: 1,
      name: "AI Sales Call Auditor",
      description: "Developed an AI-powered sales call auditor using RAG, vector DB, and LLMs for transcript analysis. Implemented microservices architecture with async communication for scalable processing.",
      impact: "5X increase in productivity, reduced team size from 50 to 10 members",
      technologies: ["RAG", "Vector DB", "LLM", "Microservices", "Async Communication"]
    },
    {
      id: 2,
      name: "Online Path Lab",
      description: "Created an app similar to Thyrocare, based on microservices architecture including sync and async communication-based Spring Boot application.",
      impact: "Complete health test management system with multiple microservices",
      technologies: ["Spring Boot", "Microservices", "Serverless Functions", "Async Communication"]
    }
  ],
  achievements: [
    {
      id: 1,
      type: "Patent",
      title: "Apparatus for Automatically Generating a Structured Service Request Interface",
      description: "Built POC for a feature allowing users to create service request tickets using multimedia content, fetching information to enhance ticket details for AI agents."
    },
    {
      id: 2,
      type: "Award",
      title: "High Performance Employee Award",
      organization: "Jio Platforms",
      description: "Recognized and awarded by the leadership team for high performance and contributions towards new services."
    },
    {
      id: 3,
      type: "Certification",
      title: "Oracle Certified Associate, Java SE 8 Programmer",
      organization: "Oracle",
      description: "Professional certification in Java programming."
    }
  ],
  education: {
    degree: "Bachelor of Technology in Computer Science and Engineering",
    institution: "Techno India College of Technology",
    duration: "2015 - 2019",
    location: "Kolkata, India"
  }
};